import { render } from "./SelfInvitation.vue?vue&type=template&id=4607d816"
import script from "./SelfInvitation.vue?vue&type=script&lang=js"
export * from "./SelfInvitation.vue?vue&type=script&lang=js"

import "./SelfInvitation.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__